






















import Vue from 'vue'
import dayjs from 'dayjs'
import { AppServiceProxy, App } from '@/service-proxies/app-v2/system.service-proxies'
import MenuList from './components/MenuList.vue'
const appServiceProxy = new AppServiceProxy()
export default Vue.extend ({
  // App菜单
  name: '',
  components: {
    MenuList
  },
  data() {
    return {
      appList: [],
      selectedAppIndex: 0,
      filter: ''
    }
  },
  created() {
    this.loadAppList()
  },

  watch: {
  },
  methods: {
    chooseApp(index: number) {
      this.selectedAppIndex = index
    },
    loadAppList () {
      appServiceProxy.pageForCode(1, this.filter, 9999).then(res => {
        this.appList = res.records
        this.selectedAppIndex = 0
      })
    }
  }
})
